import { Icon_refresh } from '@yanolja-org/ya-com-system-icon'
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '~/app/components/common/Button/Button'
import styled from '~/app/components/styled'

const RetryButton = styled(Button)`
  display: inline-block;
  width: 7.6rem;
`

/**
 * 국내주문 주문정보 새로고침 버튼
 * - 국내숙소, 기차, 버스 취소규정 fail
 * - 예약내역/상세 레저 API fail
 */
const FetchRetryButton = ({ onClick }) => (
  <RetryButton
    type={BUTTON_TYPE.BASIC}
    size={BUTTON_SIZE.XS}
    title={'새로고침'}
    iconElement={<Icon_refresh />}
    onClick={onClick}
    isDisabledEventDelegation={true}
  />
)

export default FetchRetryButton
